{
  "enum": {
    "IxcPortfolioV1AssetBalanceStatus": {
      "OPEN": "Open",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPortfolioV1BalanceSnapshotStatus": {
      "ACTIVE": "Active",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPortfolioV1CashBalanceStatus": {
      "OPEN": "Open",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPortfolioV1DepositAdvanceStatus": {
      "GRANTED": "Granted",
      "REVERSED": "Reversed",
      "SETTLED": "Settled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPortfolioV1DividendPaymentCategory": {
      "MISC": "Misc",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPortfolioV1HoldStatus": {
      "HELD": "Held",
      "REJECTED": "Rejected",
      "RELEASED": "Released",
      "REQUESTED": "Requested",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPortfolioV1HoldType": {
      "TRADE": "Trade",
      "TRANSFER": "Transfer",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPortfolioV1MarginType": {
      "CASH": "Cash",
      "LPM": "LPM",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPortfolioV1SweepBalanceStatus": {
      "OPEN": "Open",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPortfolioV1TaxLotMethod": {
      "CUSTOM": "Custom",
      "FIFO": "Fifo",
      "LIFO": "Lifo",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPortfolioV1TransactionStatus": {
      "PENDING": "Pending",
      "SETTLED": "Settled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcPortfolioV1UnrealizedDividendSource": {
      "OWNED": "Owned",
      "SWEEP": "Sweep",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceListFilterableFields": {
      "accountId": "Account",
      "assetId": "Asset",
      "data": {
        "asset": {
          "assetId": "Asset",
          "data": {
            "category": "Category",
            "type": {
              "!type": "Asset Type",
              "equity": {
                "controls": {
                  "canBuy": "Equity Controls Can Buy",
                  "canEnterFractions": "Equity Controls Can Enter Fractions",
                  "canSell": "Equity Controls Can Sell"
                },
                "cusip": "Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Money Market Classification",
                "controls": {
                  "canBuy": "Money Market Controls Can Buy",
                  "canEnterFractions": "Money Market Controls Can Enter Fractions",
                  "canSell": "Money Market Controls Can Sell"
                },
                "cusip": "Money Market CUSIP",
                "navType": "Money Market NAV Type"
              }
            }
          },
          "status": "Status"
        }
      },
      "programId": "Program",
      "status": "Status"
    },
    "IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotListFilterableFields": {
      "accountId": "Account",
      "assetId": "Asset",
      "groupId": "Group ID",
      "programId": "Program",
      "snapshotId": "Snapshot ID",
      "status": "Status"
    },
    "IxcPortfolioV1CashBalanceQueryServiceCashBalanceListFilterableFields": {
      "accountId": "Account",
      "programId": "Program",
      "status": "Status"
    },
    "IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceListFilterableFields": {
      "accountId": "Account",
      "fundingId": "Funding",
      "programId": "Program",
      "status": "Status"
    },
    "IxcPortfolioV1HoldQueryServiceHoldListFilterableFields": {
      "accountId": "Account",
      "assetId": "Asset",
      "data": {
        "asset": {
          "assetId": "Asset",
          "data": {
            "category": "Category",
            "type": {
              "!type": "Asset Type",
              "equity": {
                "controls": {
                  "canBuy": "Equity Controls Can Buy",
                  "canEnterFractions": "Equity Controls Can Enter Fractions",
                  "canSell": "Equity Controls Can Sell"
                },
                "cusip": "Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Money Market Classification",
                "controls": {
                  "canBuy": "Money Market Controls Can Buy",
                  "canEnterFractions": "Money Market Controls Can Enter Fractions",
                  "canSell": "Money Market Controls Can Sell"
                },
                "cusip": "Money Market CUSIP",
                "navType": "Money Market NAV Type"
              }
            }
          },
          "status": "Status"
        }
      },
      "entityId": "Entity ID",
      "entityType": "Entity Type",
      "holdId": "Hold",
      "programId": "Program",
      "status": "Status"
    },
    "IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceListFilterableFields": {
      "accountId": "Account",
      "assetId": "Asset",
      "data": {
        "asset": {
          "assetId": "Asset",
          "data": {
            "category": "Category",
            "type": {
              "!type": "Asset Type",
              "equity": {
                "controls": {
                  "canBuy": "Equity Controls Can Buy",
                  "canEnterFractions": "Equity Controls Can Enter Fractions",
                  "canSell": "Equity Controls Can Sell"
                },
                "cusip": "Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Money Market Classification",
                "controls": {
                  "canBuy": "Money Market Controls Can Buy",
                  "canEnterFractions": "Money Market Controls Can Enter Fractions",
                  "canSell": "Money Market Controls Can Sell"
                },
                "cusip": "Money Market CUSIP",
                "navType": "Money Market NAV Type"
              }
            }
          },
          "status": "Status"
        }
      },
      "programId": "Program",
      "status": "Status"
    },
    "IxcPortfolioV1TransactionQueryServiceTransactionListFilterableFields": {
      "accountId": "Account",
      "data": {
        "assets": {
          "asset": {
            "assetId": "Asset",
            "data": {
              "category": "Category",
              "type": {
                "!type": "Type",
                "equity": {
                  "controls": {
                    "canBuy": "Equity Controls Can Buy",
                    "canEnterFractions": "Equity Controls Can Enter Fractions",
                    "canSell": "Equity Controls Can Sell"
                  },
                  "cusip": "Equity CUSIP"
                },
                "moneyMarket": {
                  "classification": "Money Market Classification",
                  "controls": {
                    "canBuy": "Money Market Controls Can Buy",
                    "canEnterFractions": "Money Market Controls Can Enter Fractions",
                    "canSell": "Money Market Controls Can Sell"
                  },
                  "cusip": "Money Market CUSIP",
                  "navType": "Money Market NAV Type"
                }
              }
            },
            "status": "Status"
          }
        },
        "detail": {
          "!type": "Data Type"
        }
      },
      "programId": "Program",
      "status": "Status",
      "transactionId": "Transaction"
    }
  },
  "oneOf": {
    "IxcPortfolioV1AssetBalanceEventType": {
      "balanceSnapshot": "Balance Snapshot",
      "config": "Config",
      "holdCreated": "Hold Created",
      "holdModified": "Hold Modified",
      "holdRejected": "Hold Rejected",
      "holdRequested": "Hold Requested",
      "sweptBalanceUpdated": "Swept Balance Updated",
      "transactionPosted": "Transaction Posted",
      "transactionSettled": "Transaction Settled",
      "transactionSlated": "Transaction Slated"
    },
    "IxcPortfolioV1BalanceSnapshotEventType": {
      "adjustment": "Adjustment",
      "assetBalance": "Asset Balance",
      "created": "Created",
      "lateTransaction": "Late Transaction"
    },
    "IxcPortfolioV1CashBalanceEventType": {
      "advanceGranted": "Advance Granted",
      "advanceReversed": "Advance Reversed",
      "advanceSettled": "Advance Settled",
      "config": "Config",
      "holdCreated": "Hold Created",
      "holdModified": "Hold Modified",
      "holdRejected": "Hold Rejected",
      "holdRequested": "Hold Requested",
      "transactionPosted": "Transaction Posted",
      "transactionSettled": "Transaction Settled",
      "transactionSlated": "Transaction Slated"
    },
    "IxcPortfolioV1DeltaTax": {
      "close": "Close",
      "open": "Open"
    },
    "IxcPortfolioV1DepositAdvanceEventType": {
      "granted": "Granted",
      "reversed": "Reversed",
      "settled": "Settled"
    },
    "IxcPortfolioV1HoldEventType": {
      "canceled": "Canceled",
      "held": "Held",
      "rejected": "Rejected",
      "released": "Released",
      "requested": "Requested",
      "updated": "Updated",
      "used": "Used"
    },
    "IxcPortfolioV1HoldOutcome": {
      "fullPosition": "Full Position",
      "rejected": "Rejected",
      "success": "Success"
    },
    "IxcPortfolioV1SweepBalanceEventType": {
      "config": "Config",
      "transactionPosted": "Transaction Posted",
      "transactionSettled": "Transaction Settled",
      "transactionSlated": "Transaction Slated"
    },
    "IxcPortfolioV1TransactionEventType": {
      "posted": "Posted",
      "settled": "Settled",
      "slated": "Slated"
    }
  },
  "polymorph": {
    "IxcPortfolioV1TransactionDetail": {
      "ixc": {
        "billing": {
          "v1": {
            "ChargeTransaction": "Charge",
            "CustomerChargeTransaction": "Customer Charge"
          }
        },
        "corpactions": {
          "v1": {
            "CorpactionTransaction": "Corporate Action"
          }
        },
        "funding": {
          "v1": {
            "FundingBatchTransaction": "Funding Batch",
            "FundingTransaction": "Funding"
          }
        },
        "mutualfunds": {
          "v1": {
            "FundTransaction": "Fund Transaction"
          }
        },
        "orders": {
          "v1": {
            "BatchAllocationAvgPriceTransaction": "Batch Allocation Avg Price",
            "BatchAllocationCustomerTransaction": "Batch Allocation Customer",
            "BatchRemainderInventoryTransaction": "Batch Remainder Inventory",
            "TradeTransaction": "Trade"
          }
        },
        "portfolio": {
          "v1": {
            "DividendPaymentTransaction": "Dividend Payment"
          }
        },
        "sweeps": {
          "clearing": {
            "v1": {
              "SweepsTransaction": "Sweeps"
            }
          }
        }
      }
    }
  },
  "searchEnum": {
    "IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceListSearchableFields": {
      "data": {
        "asset": {
          "data": {
            "type": {
              "equity": {
                "name": "Equity Name",
                "symbol": {
                  "base": "Equity Symbol Base"
                }
              },
              "moneyMarket": {
                "name": "Money Market Name",
                "symbol": {
                  "base": "Money Market Symbol Base"
                }
              }
            }
          }
        }
      }
    },
    "IxcPortfolioV1HoldQueryServiceHoldListSearchableFields": {
      "data": {
        "asset": {
          "data": {
            "type": {
              "equity": {
                "name": "Equity Name",
                "symbol": {
                  "base": "Equity Symbol Base"
                }
              },
              "moneyMarket": {
                "name": "Money Market Name",
                "symbol": {
                  "base": "Money Market Symbol Base"
                }
              }
            }
          }
        }
      }
    },
    "IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceListSearchableFields": {
      "data": {
        "asset": {
          "data": {
            "type": {
              "equity": {
                "name": "Equity Name",
                "symbol": {
                  "base": "Equity Symbol Base"
                }
              },
              "moneyMarket": {
                "name": "Money Market Name",
                "symbol": {
                  "base": "Money Market Symbol Base"
                }
              }
            }
          }
        }
      }
    },
    "IxcPortfolioV1TransactionQueryServiceTransactionListSearchableFields": {
      "data": {
        "assets": {
          "asset": {
            "data": {
              "type": {
                "equity": {
                  "name": "Equity Name",
                  "symbol": {
                    "base": "Equity Symbol Base"
                  }
                },
                "moneyMarket": {
                  "name": "Money Market Name",
                  "symbol": {
                    "base": "Money Market Symbol Base"
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcPortfolioV1AssetBalanceQueryServiceAssetBalanceListSortableFields": {
      "data": {
        "asset": {
          "metadata": {
            "createdAt": "Asset Created At",
            "updatedAt": "Asset Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcPortfolioV1BalanceSnapshotQueryServiceBalanceSnapshotListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcPortfolioV1CashBalanceQueryServiceCashBalanceListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcPortfolioV1DepositAdvanceQueryServiceDepositAdvanceListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcPortfolioV1HoldQueryServiceHoldListSortableFields": {
      "data": {
        "asset": {
          "metadata": {
            "createdAt": "Asset Created At",
            "updatedAt": "Asset Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcPortfolioV1SweepBalanceQueryServiceSweepBalanceListSortableFields": {
      "data": {
        "asset": {
          "metadata": {
            "createdAt": "Asset Created At",
            "updatedAt": "Asset Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcPortfolioV1TransactionQueryServiceTransactionListSortableFields": {
      "data": {
        "settledAt": "Data Settled At"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}